import { getBrandName } from '../../selectors'

export const getBrandTitle = state => `${getBrandName(state)} tires`
